import React, { useState } from "react";
import { MessageSquare } from "lucide-react";
import { toast } from "react-toastify";
import { sendBulkWhatsAppTemplate } from "../../api/OrderAPIs";

export const START_CONVERSATION_TEMPLATE_ID = 83264;

const isValidPhone = (phone) =>
  phone && phone !== "Unknown Phone" && phone !== "غير معروف";

const StartConversationButton = ({ order, className = "", label = "بدأ محادثه", hidden = false }) => {
  const [isSending, setIsSending] = useState(false);

  if (hidden || !isValidPhone(order?.phoneNumber)) return null;

  const handleClick = async () => {
    const confirmed = window.confirm(
      `إرسال قالب BeOn (${START_CONVERSATION_TEMPLATE_ID}) — ${label}؟\n\nالرقم: ${order.phoneNumber}`
    );
    if (!confirmed) return;

    setIsSending(true);
    try {
      const data = await sendBulkWhatsAppTemplate(START_CONVERSATION_TEMPLATE_ID, order.phoneNumber);
      if (data.processed > 0) {
        toast.success(`تم إرسال قالب ${label} (${START_CONVERSATION_TEMPLATE_ID}) بنجاح`);
      } else {
        const failed = data.results?.find((r) => !r.success);
        toast.warning(failed?.error || "فشل إرسال القالب");
      }
    } catch (err) {
      toast.error(err.message || "فشل إرسال القالب");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isSending}
      title={`إرسال قالب BeOn (${START_CONVERSATION_TEMPLATE_ID}) — ${label}`}
      className={`bg-emerald-600 text-white px-3 py-2 rounded-lg hover:bg-emerald-700 disabled:opacity-50 text-sm font-medium transition-all ${className}`}
    >
      <div className="flex items-center justify-center gap-1">
        <MessageSquare size={14} />
        {isSending ? "جاري الإرسال..." : label}
      </div>
    </button>
  );
};

export default StartConversationButton;
